import React, {Component, Fragment} from 'react';
import Select, {components} from 'react-select';
import SelectBase from "./components/global/SelectBase";
import {Dropdown} from 'react-bootstrap';
import DropdownToggle from "./components/global/DropdownToggle";
import Menu from "./components/select-filter/Menu";
import MenuList from "./components/select-filter/MenuList";
import Option from "./components/select-filter/Option";
import SingleValue from "./components/select-filter/SingleValue";
import SelectContainer from "./components/select-search/SelectContainer";
import DropdownIndicator from "./components/select-search/DropdownIndicator";
import '../../../assets/sass/components/react-select.scss';
import SelectChips from "./components/SelectChips";

class SelectSearch extends SelectBase {

    filterSearchBtn = React.createRef();
    filterSearchMenu = React.createRef();

    componentDidUpdate(prevProps) {
        var $this = this;

        if (this.props.menuPosition) {
            setTimeout(function () {
                var select = $this.filterSearchBtn.current;
                var menu = $this.filterSearchMenu.current;
                $this.setMenuPosition(select, menu)
            }, 1)
        }
    }

    dropDownToggle = (toggle) => {
        if (toggle) {
            this.onMenuOpen();
        } else {
            this.onMenuClose();
        }

        this.setState({toggle});
    }

    placeholder = () => {
        var placeholder = this.props.placeholder ? this.props.placeholder : 'Select ...';
        if (this.props.selected) {
            if (this.state.selectedAllChecked) {
                return placeholder
            } else {

                var count = (
                    this.state.inOptions.length > 0
                        ? this.state.inOptions
                        : this.state.selectedOptions
                ).filter((item, key) => {
                    return item.checked == true
                }).length;

                return count ? `${count} Selections` : placeholder
            }
        } else {
            return placeholder;
        }
    }

    render() {
        return (
            <Fragment>
                <Dropdown className={this.setClasses(this.props, 'filter-checkbox filter-search')} onToggle={this.dropDownToggle} show={this.props.menuIsOpen ?? this.state.menuIsOpen}>
                    {/*replace DropdownButton*/}
                    <Dropdown.Toggle ref={this.filterSearchBtn} as={DropdownToggle} toggle={this.props.menuIsOpen ?? this.state.menuIsOpen}>
                        {this.placeholder()}
                    </Dropdown.Toggle>
                    {/*placement issue*/}
                    <Dropdown.Menu ref={this.filterSearchMenu} className={['react-select-dropdown-menu react-select-filter-menu', this.arrowAutoPlacement(this.state.menuPlacement, this.state.placement)].join(' ')} show={this.props.menuIsOpen ?? this.state.menuIsOpen}>
                        <Select
                            {...this.props}
                            ref={this.select}
                            type={this.props.type}
                            name={this.props.name}
                            classNamePrefix="react-select"
                            placeholder={this.props.searchPlaceholder}
                            // defaultValue={this.state.inOptions[0]}
                            options={this.state.inOptions}
                            // filterOption={this.filterOptions}
                            components={{
                                Menu,
                                MenuList,
                                Option,
                                DropdownIndicator,
                                SingleValue,
                                SelectContainer,
                                IndicatorSeparator: () => null
                            }}
                            filterButtons={this.filterButtons}
                            isAllChecked={this.state.isAllChecked}
                            onCheckChange={this.onCheckChange}
                            onDoneClick={this.onDoneClick}
                            onCloseClick={this.onCloseClick}
                            // placement issue
                            menuPlacement="bottom"

                            backspaceRemovesValue={false}
                            controlShouldRenderValue={false}
                            hideSelectedOptions={false}
                            isClearable={false}
                            tabSelectsValue={false}
                            maxMenuHeight="auto"
                            autoFocus
                            menuIsOpen
                        />
                    </Dropdown.Menu>
                </Dropdown>
                <SelectChips show={this.props.showTag ?? false} options={this.state.selectedOptions} allChecked={!this.state.selectedAllChecked} removetag={this.removeSelected}/>
            </Fragment>
        );
    }
}

SelectSearch.options = (options) => options.map((option, index) => ({key: index, ...option}));
export default SelectSearch;
